import type { ReactNode } from "react";
import { Button } from "@design-system/Button/Button";
import { useDataGridContext } from "../DataGridContext";
import { StateMessage } from "./StateMessage";
import styles from "./states.module.scss";

interface DataGridEmptyProps {
    /** Shown when there is no data at all. Defaults to "No {noun} yet". */
    children?: ReactNode;
}

/**
 * Renders only when the table is ready with zero rows. With a search or
 * filter active it shows "No results" and a Clear filters button instead of
 * `children`.
 */
export const DataGridEmpty = ({ children }: Readonly<DataGridEmptyProps>) => {
    const { isEmpty, hasActiveFilters, clearFilters, noun } =
        useDataGridContext();
    if (!isEmpty) {
        return null;
    }
    if (hasActiveFilters) {
        return (
            <StateMessage role="status">
                <p className={styles.title}>No results</p>
                <Button variant="secondary" size="sm" onClick={clearFilters}>
                    Clear filters
                </Button>
            </StateMessage>
        );
    }
    return (
        <StateMessage role="status">
            {children ?? <p className={styles.title}>No {noun} yet</p>}
        </StateMessage>
    );
};
